import type { APIRequestBody } from './base-fetch';
import { get, post, type APIResponse } from './base-fetch';

export type ProjectListingProjectFitResponse =
  APIResponse<'/api/v4/listings/{projectListingId}/project-fit'>;

export const getProjectListingProjectFit = async (projectListingId: string) => {
  return get<ProjectListingProjectFitResponse>(
    `/v4/listings/${projectListingId}/project-fit`,
  );
};

type UpdateProjectListingProjectFitResponse =
  APIResponse<'/api/v4/listings/{projectListingId}/add-project-fit'>;
export type UpdateProjectListingProjectFitPayload =
  APIRequestBody<'/api/v4/listings/{projectListingId}/add-project-fit'>;

export type UpdateProjectListingProjectFitData = {
  projectListingId: string;
  projectFitText: string | null;
};

export const updateProjectListingProjectFit = async ({
  projectListingId,
  projectFitText,
}: UpdateProjectListingProjectFitData) => {
  await post<
    UpdateProjectListingProjectFitResponse,
    UpdateProjectListingProjectFitPayload
  >(`/v4/listings/${projectListingId}/add-project-fit`, {
    projectFitText,
  });
};
